/**
 * 首页
 * @returns ReactElement
 */
import { GetStaticProps } from 'next';
import { getMessage } from '@web3/base-lang';
import { GetStaticPaths } from 'next';
import { ALL_LOCALES, relativeToAbsolute } from '@web3/base-utils';
import { useEffect, useState } from 'react';
import { useScreenType } from '@/hooks/media';
import { AddSolidIcon } from '@bfe/moly-icons';
import { Web3SecondHeader } from '@web3fe/infra';
import { useSeo } from '@web3fe/infra';
import { useFm, useWallet } from '@web3/base-hooks';
import {
  Banner,
  SectionHotActivity,
  SectionDailyActivity,
  SectionFAQ,
  InvateArea,
  SectionWork,
  SectionJoin,
  RewardModal,
} from '@/containers/home';
import cls from 'classnames';
import { useEligibility } from '@/containers/home/hooks';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

import styles from './index.module.scss';

export default function Home() {
  const [videoShow, setVideoShow] = useState(false);
  const { isMobile, width } = useScreenType();
  const { isLogin } = useWallet();
  const fm = useFm();
  const { eligibilityCount } = useEligibility();

  const videoPoster = relativeToAbsolute(
    'https://fh-static.bycsi.com/video-dad282f08d2d16dd77b15a11291b329c.png'
  );
  const videoUrl = relativeToAbsolute(
    'https://fh-static.bycsi.com/999999-e2c059883ded0cf18380cc1561c0a28b.mp4'
  );

  const handleClose = () => {
    setVideoShow(false);
  };
  const showVideo = () => {
    setVideoShow(true);
  };

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: Page.AirdropArcadeHome,
    });
  }, []);

  useSeo({
    // 实际的seo不在 scr 项目里渲染，所以就不加别的seo内容了
    title: fm('rewardsSeoTitle'),
    desc: fm('rewardsSeoDesc'),
    keywords: fm('airdropSeoKeyword'),
  });

  return (
    <div
      className={cls('home-wrap', 'text-white', 'homeIndexContainer')}
      style={{ minHeight: isMobile ? 'auto' : 'calc(100vh - 424px)' }}
    >
      <div>
        <div className={cls('main', styles.web3Header)}>
          <Web3SecondHeader />
        </div>
        <Banner eligibilityCount={eligibilityCount} />
        <div className="main pb-20 px-4 !md:px-0">
          <SectionHotActivity />

          <SectionDailyActivity />

          <SectionFAQ showVideo={showVideo} />

          <SectionWork />

          <SectionJoin />

          <RewardModal eligibilityCount={eligibilityCount} />
        </div>

        {videoShow && (
          <div className={cls(['video-modal', videoShow && 'is-visible'])}>
            <div className="video-body">
              <AddSolidIcon
                className="video-close w-6 h-6"
                onClick={handleClose}
              />

              <video
                width={isMobile ? width * 0.9 : '960'}
                height={isMobile ? (width * 543) / 960 : '543'}
                className="video-iframe"
                src={videoUrl}
                // autoPlay
                poster={videoPoster}
                controls
              ></video>
            </div>
          </div>
        )}
        {isLogin && <InvateArea />}
      </div>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage('web3-airdrop', {
    locale,
    entry: import.meta.url,
    additions: ['airdropSeoTitle', 'airdropKeyword', 'airdropSeoDesc'],
  });

  return {
    props: {
      locale,
      messages,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};
